<template>
  <div class="mySlides fade ">
    <img :src="image">
  </div>
</template>

<script>
  export default {
    name: '',
    props: ['image'],
    data () {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>